// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isRecentInteractionsResult = objectOf({
  recent_interactions: arrayOf(
    objectOf({
      type: string,
      _id: string,
      name: string,
      description: string,
      readable_status: string,
      timestamp: string,
      interaction_type: string,
    })
  ),
  error: boolean,
});
